// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"src-components-ErrorBoundary---wrapper---1b4JM"};